import React, { useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../AuthContext";

const Login = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) navigate("/admin");
  }, [user, loading, navigate]);

  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-ink text-white flex items-center justify-center px-6">
      <div className="w-full max-w-md text-center">
        <Link to="/" className="inline-block">
          <img src="/horns-logo-dark.webp" alt="Horns Industriservice" className="h-10 w-auto mx-auto" />
        </Link>
        <p className="overline text-gold mt-4">Admin</p>
        <div className="mt-12 border border-white/15 p-10">
          <h1 className="font-serif text-3xl font-light">Välkommen tillbaka</h1>
          <p className="mt-4 text-white/60 font-light text-sm">Logga in med ditt Google-konto för att hantera webbplatsen.</p>
          <button onClick={handleLogin}
            className="mt-8 w-full bg-white text-ink hover:bg-gold hover:text-white transition-colors duration-300 py-4 flex items-center justify-center gap-3 text-sm tracking-[0.12em]">
            <svg width="18" height="18" viewBox="0 0 48 48"><path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/><path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/></svg>
            Logga in med Google
          </button>
          <p className="mt-6 text-white/40 text-xs">Endast behöriga konton (info@horns.se) släpps in.</p>
        </div>
        <Link to="/" className="inline-block mt-8 text-white/50 hover:text-gold-light text-sm transition-colors">← Tillbaka till webbplatsen</Link>
      </div>
    </div>
  );
};

export default Login;
